export const badgeVariants = {
  primary: 'eye:bg-yellow-100',
  secondary: 'eye:bg-white',
  error: 'eye:bg-red-25 eye:border-red-100',
  success: 'eye:bg-green-25',
  warning: 'eye:bg-yellow-35 eye:border-olive-100',
  info: 'eye:bg-blue-25 eye:border-blue-150',
} as const;
